<!-- @format -->

<template>
	<div class="column-default-column-setting">
		<template v-for="item in transSettingColumnConfig[0]" :key="item.value">
			<el-button
				:disabled="item.isDisabled"
				type="primary"
				link
				v-bind="item.prop"
				@click.stop="settingAction(item.value)"
			>
				{{ item.label }}
			</el-button>
		</template>

		<el-dropdown v-if="transSettingColumnConfig[1].length" @command="(e) => settingAction(e)">
			<el-button v-if="transSettingColumnConfig[1].length" type="primary" link @click.stop> 更多 </el-button>
			<template #dropdown>
				<el-dropdown-menu>
					<template v-for="item in transSettingColumnConfig[1]" :key="item.value">
						<el-dropdown-item :disabled="item.isDisabled" :command="item.value">
							{{ item.label }}
						</el-dropdown-item>
					</template>
				</el-dropdown-menu>
			</template>
		</el-dropdown>
	</div>
</template>

<script setup lang="ts">
	import { SettingColumnConfigType } from './types';
	import { PcModal } from '@/components';

	interface Props {
		data: Record<string, any>;
		settingColumnConfig?: SettingColumnConfigType[];
		settingColumnShowLength?: number;
	}

	interface SettingColumnConfigTypes extends SettingColumnConfigType {
		isDisabled: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		settingColumnShowLength: 2,
	});

	const emits = defineEmits(['settingAction']);

	const transSettingColumnConfig = ref<[SettingColumnConfigTypes[], SettingColumnConfigTypes[]]>([[], []]);

	const setTransSettingColumnConfig = (data): [SettingColumnConfigTypes[], SettingColumnConfigTypes[]] => {
		if (props.settingColumnConfig) {
			const settingList = props.settingColumnConfig.reduce((arr: SettingColumnConfigTypes[], item) => {
				if (typeof item.hidden === 'function' ? !item.hidden(data) : !item.hidden) {
					const itm: SettingColumnConfigTypes = {
						...item,
						isDisabled: typeof item.disabled === 'function' ? item.disabled(data) : !!item.disabled,
					};
					return arr.concat(itm);
				}
				return arr;
			}, []);
			return [settingList.slice(0, props.settingColumnShowLength), settingList.slice(props.settingColumnShowLength)];
		}
		return [[], []];
	};

	const settingAction = (type) => {
		const item = props.settingColumnConfig?.find((it) => it.value === type);
		if (item?.twiceConfirm) {
			const { ...conProp } = (item.confirmProps || {}) as any;
			PcModal.PcMessageBox({ ...conProp, message: conProp.message || conProp.content })
				.then(({ done }) => {
					emits('settingAction', type, () => {
						done();
					});
				})
				.catch(({ done }) => {
					done();
				});
		} else {
			emits('settingAction', type, () => {});
		}
	};

	watch(
		() => props.data,
		(newVal) => {
			transSettingColumnConfig.value = setTransSettingColumnConfig(newVal);
		},
		{
			immediate: true,
		},
	);
</script>

<style scoped lang="scss">
	.column-default-column-setting {
		display: flex;
		justify-content: flex-start;

		.el-button {
			margin-left: 0px !important;
		}

		.el-button + .el-button {
			margin-left: 5px;
		}
	}
</style>
